module.exports = __webpack_public_path__ + "img/default-avatar.0e3e5060.png";